import { useReveal } from '@/hooks/useReveal';
import { useRtlDirection } from '@/hooks/useRtlDirection';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import MobileCTA from '@/components/feature/MobileCTA';
import Hero from './components/Hero';
import IntroSection from './components/IntroSection';
import CompareSection from './components/CompareSection';
import GarageSystemsSection from './components/GarageSystemsSection';
import ArchitectureSection from './components/ArchitectureSection';
import B2BSection from './components/B2BSection';
import B2CSection from './components/B2CSection';
import WinterGardenSection from './components/WinterGardenSection';
import ProcessSection from './components/ProcessSection';
import GallerySection from './components/GallerySection';
import LeadForm from './components/LeadForm';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  useRtlDirection();
  useReveal();

  return (
    <>
      <Header />
      <main>
        <Hero />
        <IntroSection />
        <CompareSection />
        <GarageSystemsSection />
        <ArchitectureSection />
        <B2BSection />
        <B2CSection />
        <WinterGardenSection />
        <ProcessSection />
        <GallerySection />
        <LeadForm />
        <FAQSection />
        <AboutSection />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <MobileCTA />
    </>
  );
}